"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var text_1 = require("./text");
function TextareaLfDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/textarea-lf.html',
        controller: /** @class */ (function (_super) {
            __extends(TextareaLfController, _super);
            function TextareaLfController($element, $timeout, $scope, book) {
                'ngInject';
                var _this = _super.call(this, $scope, book) || this;
                _this.$element = $element;
                _this.$timeout = $timeout;
                _this.textarea = _this.$element.find('textarea')[0];
                _this.initalized = true;
                return _this;
            }
            TextareaLfController.prototype.onChange = function () {
                var _this = this;
                if (!this.initalized) {
                    return;
                }
                var start = this.textarea.selectionStart;
                var end = this.textarea.selectionEnd;
                this.form.value = this.addLineBreaks(this.form.value);
                if (typeof this.form.value === 'undefined'
                    || this.regexp && !this.regexp.test(this.form.value)
                    || !this.checkText(this.form.value)) {
                    this.form.value = this.book.get(this.prefix, this.id);
                }
                else {
                    this.book.set(this.prefix, this.id, this.form.value);
                }
                if (start === end) {
                    this.$timeout(function () {
                        _this.textarea.setSelectionRange(start, end);
                    });
                }
            };
            TextareaLfController.prototype.getRows = function () {
                var lfs = this.form.value.match(/\n/g) || [];
                return lfs.length + 1;
            };
            TextareaLfController.prototype.getProgress = function () {
                var rows = this.form.value.split('\n');
                var last = rows.pop();
                var percent = 100 / this.maxRows * rows.length
                    + 100 / this.maxCols * last.length / this.maxRows;
                return Math.min(100, percent);
            };
            TextareaLfController.prototype.checkText = function (text) {
                var _this = this;
                var rows = text.split('\n');
                return rows.length <= this.maxRows
                    && rows.findIndex(function (row) { return row.length > _this.maxCols; }) < 1;
            };
            TextareaLfController.prototype.addLineBreaks = function (text) {
                var rows = text.split('\n');
                for (var i = 0; i < rows.length; i++) {
                    if (rows[i].length <= this.maxCols) {
                        continue;
                    }
                    var j = 0;
                    var space = this.maxCols;
                    while (j++ <= this.maxCols) {
                        if (rows[i].charAt(j) === ' ') {
                            space = j;
                        }
                    }
                    rows[i + 1] = rows[i].substring(space + 1) + (rows[i + 1] ? ' ' + rows[i + 1] : '');
                    rows[i] = rows[i].substring(0, space);
                }
                text = rows.join('\n');
                return text;
            };
            return TextareaLfController;
        }(text_1.TextController)),
        controllerAs: 'textareaCtrl'
    };
}
exports.TextareaLfDirective = TextareaLfDirective;
